angular.module('bmsApp.merrymaids.schedule').controller('MMScheduleCtrl', function ($state,
																					$scope,
																					moment,
																					$q,
																					$window,
																					$timeout,
																					$stateParams,
																					$location,
																					uiGmapGoogleMapApi,
																					uiGmapIsReady,
																					ManualRouteSvc,
																					NotificationSvc) {



	NotificationSvc.disable();

	$scope.config.uiTimepickerOptions.appendTo = 'body';

	var self = $scope.MMScheduleCtrl = {
		methods: {
			init: function () {

				// input should be json encoded then base 64 encode, decode...
				self.input = JSON.parse(atob($location.search().query));
				self.route = self.input;

				var failedGeocodes = false;
				angular.forEach(self.route.waypoints, function(waypoint) {
					if ((waypoint.latitude == null || waypoint.longitude == null)) {
						failedGeocodes = true;
					}
				});

					self.failedGeocode = failedGeocodes;

				self.route.start_time = moment(self.input.start_time, 'HH:mm:ss');
				$q.all({
					uiGmapIsReady: uiGmapIsReady,
					start_location: self.methods.getAddressGeometry(self.input.start_postcode).then(function (result) {
						var location = result[0].geometry.location;
						self.map.start_location = {
							id: 1,
							coords: {
								latitude: location.lat(),
								longitude: location.lng()
							},
							options: {
								icon: 'images/markers/marker-icon-checkered-flag.png'
							}
						}
					}),
					finish_location: self.methods.getAddressGeometry(self.input.finish_postcode).then(function (result) {
						var location = result[0].geometry.location;
						self.map.finish_location = {
							id: 1,
							coords: {
								latitude: location.lat(),
								longitude: location.lng()
							},
							options: {
								icon: 'images/markers/marker-icon-checkered-flag.png'
							}
						}
					})
				})
					.then(function () {
						self.map.ready = true;
						self.route.waypoints = self.input.waypoints;

						//self.route.start_time = moment(self.input.start_time, 'HH:mm:ss');
						//self.route.start_time = momentinput.start_time;
						self.route.clean_duration = 0;
						angular.forEach(self.route.waypoints, function (waypoint) {
							self.route.clean_duration += parseInt(waypoint.duration) * 60;
						});
						self.methods.updateWaypointOrder();
						self.methods.getRoute();

					});
				//self.start_postcode = input.start_postcode;
				//self.finish_postcode = input.finish_postcode;
			},
			getAddressGeometry: function (address) {
				var deferred = $q.defer();
				uiGmapGoogleMapApi.then(function (maps) {
					var geocoder = new maps.Geocoder();
					geocoder.geocode({
						address: address
					}, function (result, status) {
						if (status === 'OK') {
							deferred.resolve(result);
						}
					});
				});
				return deferred.promise;
			},
			postMessage: function (data, domain) {
				domain = domain || '*';
				$window.parent.postMessage(angular.extend({frameId: 'manual-route-frame'}, angular.copy(data)), domain);
			},
			//postState: function (action) {
			//	// Post the state of this iframe to the parent window
			//	var state = angular.extend({}, self.input, {
			//		distance: self.route.distance,
			//		travel_duration: self.route.travel_duration,
			//		waypoints: self.route.waypoints,
			//		dismiss: action ? true : false,
			//		action: action
			//	});
			//	self.methods.postMessage(state);
			//},
			removeWaypoint: function (index) {
				// dnd list handles inserting the waypoint that has been moved, need to remove old one ourselves
				self.route.waypoints.splice(index, 1);
			},
			updateWaypointOrder: function () {
				// Reset the order attribute which will be save against each route waypoint
				var order = 0;
				angular.forEach(self.route.waypoints, function (waypoint) {
					waypoint.order = order;
					waypoint.icon = 'images/markers/marker-icon-' + (order + 1) + '.png';
					order++
				});
			},
			getRoute: function () {
				// Get route for the current waypoint and set on map
				uiGmapGoogleMapApi.then(function (maps) {
					var markers = [];
					var bounds = new maps.LatLngBounds();

					var directionsService = new maps.DirectionsService();

					var request = {
						//origin: self.start_location,
						//destination: self.finish_location,
						origin: new maps.LatLng(parseFloat(self.map.start_location.coords.latitude), parseFloat(self.map.start_location.coords.longitude)),
						destination: new maps.LatLng(parseFloat(self.map.finish_location.coords.latitude), parseFloat(self.map.finish_location.coords.longitude)),
						waypoints: [],
						travelMode: maps.TravelMode['DRIVING'],
						optimizeWaypoints: false
					};

					// Plot markers
					var id = 1;
					angular.forEach(self.route.waypoints, function (waypoint) {
						var LatLng = new maps.LatLng(parseFloat(waypoint.latitude), parseFloat(waypoint.longitude));
						bounds.extend(LatLng);
						request.waypoints.push({
							location: LatLng
						});
						markers.push({
							id: id,
							coords: {
								latitude: waypoint.latitude,
								longitude: waypoint.longitude
							},
							icon: waypoint.icon
						});
						id++;
					});

					// Plot route
					directionsService.route(request, function (response, status) {
						if (response.status === 'OK') {
							var route = [];
							var legs = response.routes[0].legs;
							// clone original start time
							var lastLeave = self.route.start_time;
							self.route.distance = 0;
							self.route.travel_duration = 0;
							for (i = 0; i < legs.length; i++) {
								var steps = legs[i].steps;
								var arrive = moment(lastLeave).add(legs[i].duration.value, 'seconds');
								if (self.route.waypoints[i]) {
									lastLeave = moment(arrive).add(self.route.waypoints[i].duration, 'minutes');
									self.route.waypoints[i].arrive = arrive.format();
									self.route.waypoints[i].leave = lastLeave.format();
									self.route.waypoints[i].travel_distance_m = legs[i].distance.value;
									self.route.waypoints[i].travel_duration_s = legs[i].duration.value;
								}
								else {
									self.route.return_time = arrive;
									self.route.return_distance_m = legs[i].distance.value;
									self.route.return_duration_s = legs[i].duration.value;
								}
								self.route.distance += legs[i].distance.value;
								self.route.travel_duration += legs[i].duration.value;
								for (j = 0; j < steps.length; j++) {
									var nextSegment = steps[j].path;
									for (k = 0; k < nextSegment.length; k++) {
										route.push({
											latitude: nextSegment[k].lat(),
											longitude: nextSegment[k].lng()
										});
										var LatLng = new maps.LatLng(nextSegment[k].lat(), nextSegment[k].lng());
										bounds.extend(LatLng);
									}
								}
							}

							// Set new markers and route onto the scope
							self.map.markers = markers;
							self.map.route.path = route;

							// Focus on the markers and routes
							uiGmapIsReady.promise(1).then(function () {
								self.map.control.getGMap().fitBounds(bounds);
							});
						}
						else {
							console.error('Failed to route waypoints');
							self.routeFailed = true;
						}
					});
				});
			},
			save: function (close) {
				var post = angular.copy(self.route);
				post.start_time = self.route.start_time.format('HH:mm:ss');

				ManualRouteSvc.save(post)
					.then(function (response) {
						self.methods.postMessage(angular.extend(response.data, {
							travel_time: self.route.travel_duration,
							distance: self.route.distance,
							estimated_finish: self.route.return_time.format($scope.config.format.date.amShortTime24),
							save: true,
							close: close || false
						}));
					});
			},
			close: function () {
				self.methods.postMessage({
					close: true
				});
			}
		},
		handlers: {
			waypointMoved: function (waypoint, index) {
				self.methods.removeWaypoint(index);
				self.methods.updateWaypointOrder();
				self.methods.getRoute();
			},
			waypointDragover: function (event, index, type, external) {
				// Drag scrolling
				var scrollIncrement = 10;
				var listContainer = angular.element('.manual-route-waypoints');
				var top = listContainer.offset().top;
				var bottom = top + listContainer.outerHeight();
				var scrollTop = listContainer.scrollTop();
				if (event.clientY - top <= 25) {
					// Scroll up
					listContainer.scrollTop(scrollTop - scrollIncrement);
				}
				if (bottom - event.clientY <= 25) {
					// Scroll down
					listContainer.scrollTop(scrollTop + scrollIncrement);
				}

				// Last class
				angular.forEach(listContainer.children(), function (child) {
					angular.element(child).removeClass('last');
				});
				listContainer.children(':visible:last').addClass('last');
				return true;
			},
			startTimeChange: function () {
				self.methods.getRoute();
			}
		},
		map: {
			ready: false,
			start_location: null,
			finish_location: null,
			markers: [],
			route: {
				path: [],
				stroke: {
					color: '#4285F4',
					opacity: 0.8
				}
			},
			control: {}
		},
		route: {
			start_time: null,
			return_time: null,
			return_distance_m: null,
			return_duration_s: null,
			distance: null,
			travel_duration: null,
			clean_duration: null,
			waypoints: null
		},
		input: null
	};

	self.methods.init();

});
